'use client';
import { useLocation, NavLink } from 'react-router-dom';
import { List, ListItemButton, ListItemText } from '@mui/material';
import { MenuItem } from '../../../types/Menu';
import { TextColor } from '../../../types/Color';

export interface MenuProps {
  items: MenuItem[];
  direction?: 'row' | 'column';
  position?: 'start' | 'center' | 'end';
  textColor?: TextColor | string;
  textDecoration?: string;
  onClick?: (isOpen: boolean) => void;
}

export function Menu({
  items: menuItems,
  direction = 'column',
  position,
  textColor,
  textDecoration = 'none',
  onClick,
}: MenuProps) {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <List
      sx={{
        display: { md: 'flex', xs: 'block' },
        flexDirection: { md: direction, xs: 'column' },
        justifyContent: position,
      }}
    >
      {menuItems.map(({ path, label, disabled = false }: MenuItem) =>
        disabled ? (
          <span
            key={path}
            style={{
              textDecoration: textDecoration,
              color: textColor,
              textDecorationColor: textColor,
            }}
          >
            <ListItemButton
              selected={pathname === path}
              disabled={disabled}
              sx={{ color: textColor }}
              aria-label={`${label} coming soon`}
            >
              <ListItemText primary={label} />
            </ListItemButton>
          </span>
        ) : (
          <NavLink
            key={path}
            to={path}
            style={{ textDecoration: textDecoration, textDecorationColor: textColor }}
          >
            <ListItemButton
              selected={pathname === path}
              disabled={disabled}
              sx={{ color: textColor }}
              aria-label={label}
              onClick={e => {
                if (onClick) {
                  onClick(false);
                } else {
                  e.preventDefault();
                }
              }}
            >
              <ListItemText primary={label} />
            </ListItemButton>
          </NavLink>
        )
      )}
    </List>
  );
}

export default Menu;
